import Modal, { ModalTitle as MT } from './presenter';
export default Modal;
export const ModalTitle = MT;
